import { BLOG_COMMENTS } from '../ids';
import { InstallLocation } from '../types';
import { formatDescription } from '../utils';
export const ids = BLOG_COMMENTS;
export const getDefinition = (staticsUrl, t) => ({
    ...BLOG_COMMENTS,
    installLocation: InstallLocation.Profile,
    social: true,
    numbers: {
        key: 'commentsCount',
        default: 0,
    },
    method: 'addSection',
    urlOverride: 'blog-comments',
    menuOrder: 2,
    page: {
        name: t('member-pages.comments.name'),
        shortDescription: t('member-pages.comments.short-description'),
        description: formatDescription({
            text: t('member-pages.comments.description.text'),
            bulletPoints: [
                t('member-pages.comments.description.bullet-point-1'),
                t('member-pages.comments.description.bullet-point-2'),
                t('member-pages.comments.description.bullet-point-3'),
            ],
        }),
        iconURL: `${staticsUrl}assets/images/icons/blog-icon.png`,
        origin: t('member-pages.origin'),
        isNew: false,
        screenshots: [
            `${staticsUrl}assets/images/blog-comments/blog-comments.png`,
            `${staticsUrl}assets/images/blog-comments/mobile-blog-comments.png`,
        ],
    },
});
//# sourceMappingURL=blog-comments.js.map